import React from "react";
import CrudPage from "./CrudPage";

export default function KeywordResearch() {
  return (
    <CrudPage
      title="Keyword Research"
      subtitle="Sole owner of keyword information (SEO Studio §5)."
      testIdPrefix="keyword"
      listUrl="/seo/keywords?limit=500"
      createUrl="/seo/keywords"
      updateUrl={(id) => `/seo/keywords/${id}`}
      deactivateUrl={(id, r) => `/seo/keywords/${id}/deactivate?change_reason=${encodeURIComponent(r)}`}
      columns={[
        { key: "phrase", label: "Phrase" },
        { key: "search_volume", label: "Volume" },
        { key: "difficulty", label: "Difficulty" },
        { key: "cluster_id", label: "Cluster" },
        { key: "priority", label: "Priority" },
      ]}
      fields={[
        { key: "phrase", label: "Phrase", type: "text" },
        { key: "search_volume", label: "Search volume", type: "number" },
        { key: "difficulty", label: "Difficulty (0–100)", type: "number" },
        { key: "competition", label: "Competition (0–1)", type: "number" },
        { key: "seasonality", label: "Seasonality", type: "text" },
        { key: "cluster_id", label: "Cluster ID", type: "text" },
        { key: "target_page", label: "Target page", type: "text" },
        { key: "priority", label: "Priority (1–10)", type: "number" },
      ]}
      emptyForm={{
        phrase: "", search_volume: "", difficulty: "", competition: "",
        seasonality: "", cluster_id: "", target_page: "", priority: "",
      }}
      fromRow={(row) => ({
        phrase: row.data.phrase || "",
        search_volume: row.data.search_volume ?? "",
        difficulty: row.data.difficulty ?? "",
        competition: row.data.competition ?? "",
        seasonality: row.data.seasonality || "",
        cluster_id: row.data.cluster_id || "",
        target_page: row.data.target_page || "",
        priority: row.data.priority ?? "",
      })}
      canonicalizeCreate={(f) => stripEmpty({
        phrase: f.phrase,
        search_volume: numOrNull(f.search_volume),
        difficulty: numOrNull(f.difficulty),
        competition: numOrNull(f.competition),
        seasonality: f.seasonality || null,
        cluster_id: f.cluster_id || null,
        target_page: f.target_page || null,
        priority: intOrNull(f.priority),
      })}
      canonicalizeUpdate={(f) => stripEmpty({
        phrase: f.phrase || undefined,
        search_volume: numOrNull(f.search_volume),
        difficulty: numOrNull(f.difficulty),
        competition: numOrNull(f.competition),
        seasonality: f.seasonality || null,
        cluster_id: f.cluster_id || null,
        target_page: f.target_page || null,
        priority: intOrNull(f.priority),
        change_reason: "edited via admin UI",
      })}
    />
  );
}

function numOrNull(v) { if (v === "" || v == null) return null; const n = Number(v); return isNaN(n) ? null : n; }
function intOrNull(v) { const n = numOrNull(v); return n == null ? null : Math.round(n); }
function stripEmpty(obj) {
  const out = {};
  for (const k in obj) if (obj[k] !== undefined) out[k] = obj[k];
  return out;
}
